<template>
  <div v-if="user" class="page">
    <SnackBar @hideSnackbar="hideSnackbar"></SnackBar>
    <LoadingOverlay></LoadingOverlay>
    <DashboardBase></DashboardBase>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import DashboardBase from '../components/dashboard/DashboardBase.vue';
import LoadingOverlay from '../components/common/LoadingOverlay.vue';
import SnackBar from '../components/common/SnackBar.vue';
import snackbarMixin from '../mixins/snackbar';

export default {
  mixins: [ snackbarMixin ],
  mounted() {
    this.$store.commit('updateCurrentView', 'Dashboard');
  },
  computed: {
    ...mapState({
      user: state => state.main.currentUser,
    }),
  },
  components: {
    DashboardBase,
    LoadingOverlay,
    SnackBar,
  },
};
</script>
